<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <form [formGroup]="changePasswordForm" class="changePasswordForm" (ngSubmit)="onSubmit()">
        <div class="content">
          <div class="form-group">
            <label for="password-label" class="password-label">New Password</label>
            <input type="password" class="form-control content-input" formControlName="password" [ngClass]="{
              'is-valid': passwordCtrl.valid && !changePasswordForm.hasError('passwordnotmatch'),
              'is-invalid': (!passwordCtrl.valid && passwordCtrl.touched) || (passwordCtrl.valid && changePasswordForm.hasError('passwordnotmatch') && confirmPasswordCtrl.value)
            }" (keypress)="$event.charCode !== 32">
            <div class="error-message" *ngIf="passwordCtrl.touched && passwordCtrl.hasError('required')">
              Please enter valid information here.
            </div>
            <div class="error-message" *ngIf="passwordCtrl.touched && passwordCtrl.hasError('pattern')">
              The password must be at least 8 characters and must contain at least one number, one upper case character and one special
              character.
            </div>
          </div>

          <div class="form-group">
            <label for="confirm-password" class="password-label">Confirm New Password</label>
            <input type="password" class="form-control content-input" formControlName="confirmPassword" autocomplete="off" [ngClass]="{
              'is-valid': passwordCtrl.valid && !changePasswordForm.hasError('passwordnotmatch'),
              'is-invalid': changePasswordForm.hasError('passwordnotmatch') && passwordCtrl.valid && confirmPasswordCtrl.touched
            }">
            <div class="error-message" *ngIf="passwordCtrl.valid && confirmPasswordCtrl.touched && !confirmPasswordCtrl.value">
              Please confirm your password
            </div>
            <div class="error-message" *ngIf="confirmPasswordCtrl.value && changePasswordForm.hasError('passwordnotmatch')">
              Password and Confirm password do not match
            </div>
          </div>

          <div class="form-group">
            <button class="btn btn-block" type="submit" [ngClass]="{
              'btn-greengo': changePasswordForm.valid,
              'btn-inactive': !changePasswordForm.valid
            }" npFocusOutClicked>Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>